import { tva } from '@gluestack-ui/utils/nativewind-utils'

/** Single definition of the task-form chip chrome; layout comes from the call site's `class`. */
export const taskChip = tva({
    base: 'rounded border border-solid',
    variants: {
        isSelected: {
            true: 'border-action-default bg-action-default',
            false: 'border-border-subtle bg-background-highlight hover:border-border-strong hover:bg-background-highlight-hover',
        },
        isDisabled: {
            true: 'pointer-events-none opacity-40',
            false: '',
        },
    },
    defaultVariants: { isSelected: false, isDisabled: false },
})
